
import React from "react";
import { useNavigate } from "react-router-dom";
import { useToast } from "@/hooks/use-toast";
import { db } from "@/integrations/cloudflare/client";
import AdminLayout from "@/components/admin/AdminLayout";
import RecipeForm from "@/components/admin/tools/recipe-ideas/RecipeForm";
import { useAdminCheck } from "@/hooks/useAdminCheck";

const NewRecipe = () => {
  const { isLoading } = useAdminCheck();
  const navigate = useNavigate();
  const { toast } = useToast();
  
  const handleSaveRecipe = async (recipeData: any) => {
    try {
      // Create new recipe
      const { data, error } = await db
        .from('holiday_recipes')
        .insert({
          title: recipeData.title,
          description: recipeData.description,
          ingredients: recipeData.ingredients,
          instructions: recipeData.instructions,
          prep_time: recipeData.prepTime,
          cook_time: recipeData.cookTime,
          total_time: recipeData.totalTime,
          servings: recipeData.servings,
          difficulty: recipeData.difficulty,
          category: recipeData.category,
          tags: recipeData.tags,
          image_url: recipeData.imageUrl,
          kid_friendly: recipeData.kidFriendly,
          created_at: new Date().toISOString(),
          updated_at: new Date().toISOString()
        })
        .select();
      
      if (error) {
        throw error;
      }
      
      toast({
        title: "Success",
        description: "Recipe created successfully"
      });
      
      // Navigate back to recipe list
      navigate("/admin/tools/recipe-generator");
    } catch (error) {
      console.error('Error saving recipe:', error);
      toast({
        title: "Error",
        description: "Failed to save recipe",
        variant: "destructive"
      });
    }
  };

  const handleCancel = () => {
    navigate("/admin/tools/recipe-generator");
  };

  if (isLoading) {
    return <div>Checking authentication...</div>;
  }

  return (
    <AdminLayout
      title="Add New Recipe"
      backLink="/admin/tools/recipe-generator"
      backLabel="Back to Recipes"
    >
      <div className="mb-6">
        <h1 className="text-2xl font-bold">Add New Recipe</h1>
        <p className="text-gray-500">Create a new holiday recipe for the recipe generator tool</p>
      </div>
      
      <RecipeForm
        recipe={null}
        onSave={handleSaveRecipe}
        onCancel={handleCancel}
      />
    </AdminLayout>
  );
};

export default NewRecipe;
